module.exports = __webpack_public_path__ + "static/cover.574fca71.png";